<template>
	<!-- SYSTEM -->
	<v-layout v-if="message.type == 'system' && !isNotification(message)" class="justify-center my-3">
		<v-chip style="height: auto">
			<div style="white-space: pre-wrap; word-break: break-word; text-align: center">
				{{ text }}
			</div>
		</v-chip>
	</v-layout>

	<!-- USER -->
	<div
		v-else-if="message.type == 'user' || message.type == 'bot'"
		class="my-3"
		:style="{
			'max-width': '80%',
			width: 'fit-content',
			'margin-left': isMe ? 'auto' : '0',
			'margin-right': isMe ? '0' : 'auto',
			background: isMe ? MY_MESSAGE : USER_MESSAGE,
			'border-radius': '20px',
		}"
		style="position: relative"
	>
		<v-layout
			style="padding: 0.5em"
			:class="{ 'recorded-message': !messageWasTyped && (showRecordedIndicator || debugStore.debugMode) }"
		>
			<Controls :message="message" />
			<MessageContent :message="message" />
		</v-layout>
	</div>

	<!-- Notifications -->
	<div
		v-else-if="message.type == 'system'"
		class="my-3 justify-center"
		:style="{
			'max-width': '70%',
			width: 'fit-content',
			'margin-left': 'auto',
			'margin-right': 'auto',
			background: isMe ? MY_MESSAGE : USER_MESSAGE,
			'border-radius': '10px',
		}"
		style="position: relative"
	>
		<div
			v-if="message.type === 'system'"
			class="nta-border"
			style="position: absolute; width: 100%; height: 100%; border-radius: 10px"
		/>
		<v-layout style="padding: 0.5em">
			<Controls :message="message" />
			<MessageContent :message="message" />
		</v-layout>
	</div>
</template>

<script setup lang="ts">
import type { Message } from "@lr-notitia/notitia-alternis/schemas";
import { ref, computed } from "vue";
import { useDomainStore } from "../../../../store/domain";
import Controls from "./Controls.vue";
import MessageContent from "./MessageContent.vue";
import { useGraphStore } from "../../../../store/graph";
import { useDebugStore } from "../../../../store/debug";

const MY_MESSAGE = "#4db6ac66";
const USER_MESSAGE = "#80808044";

const domainStore = useDomainStore();
const debugStore = useDebugStore();
const graphStore = useGraphStore();

const props = defineProps<{ message: Message }>();

const showRecordedIndicator = ref(false);

const isMe = computed(() => props.message.userId === domainStore.account.id);
const text = computed(() => props.message.words.map((s) => s.value).join(" "));
const messageWasTyped = computed(() => {
	return props.message.words.every((word) => word.probability === 1);
});

window.addEventListener("keydown", (e) => {
	if (e.altKey && domainStore.isEditorOrAdmin) showRecordedIndicator.value = true;
});
window.addEventListener("keyup", (e) => {
	if (!e.altKey) showRecordedIndicator.value = false;
});

function isNotification(message: Message) {
	return graphStore.descriptor.notification.byId(message.messageId) !== undefined;
}
</script>

<style scoped lang="scss">
.nta-border {
	box-shadow: 0 0 6px 2px #4db6ac !important;
	animation: hueRotate 4s infinite linear;
}
@keyframes hueRotate {
	0%,
	100% {
		filter: hue-rotate(0deg);
	}
	50% {
		filter: hue-rotate(-60deg);
	}
}

.recorded-message {
	border-radius: 20px;
	background-color: #4c3b8f;
}
</style>
